export default {
  cancelText: 'Annuller'
};
